import React from 'react';

type RibbonType =
    | 'badge'
    | 'info'
    | 'neutral'
    | 'negative'
    | 'positive'
    | 'warning';

const classes: { [key in RibbonType]: string } = {
    badge: 'badge--positionTL',
    info: 'badge--info',
    neutral: 'badge--neutral',
    negative: 'badge--negative',
    positive: 'badge--positive',
    warning: 'badge--warning',
};

const borderStyle = {
    borderWidth: '1px 0 0 1px',
    borderTopLeftRadius: '8px',
};

type PrimaryTagProps = {
    children?: React.ReactNode;
    className?: string;
    ribbonClass?: string;
    type: RibbonType;
};

export function PrimaryTag(props: PrimaryTagProps) {
    const { children, className = '', type = 'neutral' } = props;

    const ribbonClass = `badge badge--positionTL whitespace-nowrap ${props.ribbonClass || ''}`;

    return (
        <div className={`sf-primary-tag ${className}`}>
            <span
                className={`${ribbonClass} ${classes[type]}`}
                style={borderStyle}
            >
                {children}
            </span>
        </div>
    );
}
